export default __webpack_public_path__ + "static/sact-53da84937ff02927e1a28cc08b91e882.jpg";